function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgNetherlands = function SvgNetherlands(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M473.655,88.276H38.345C17.167,88.276,0,105.443,0,126.621v73.471h512v-73.471 C512,105.443,494.833,88.276,473.655,88.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M0,385.379c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345 v-73.471H0V385.379z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 200.09,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 111.81
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNetherlands, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/netherlands.5dbbe52e.svg";
export { ForwardRef as ReactComponent };